import { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import { canShowPermission } from '../Permissions/permissionObject';
import { useEffect } from 'react';
import InfoButton from '../../Comman/InfoButton';
import LeadList from './LeadList';
import CreateFollowup from './CreateFollowup';
import CreateLeads from './CreateLeads';
import FollowUpListByDate from './FollowUpListByDate';
import dayjs from 'dayjs';

const getMyFollowUpRange = (subTab) => {
  const today = dayjs();
  if (subTab === 0) {
    return {
      start: today.format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    };
  }
  if (subTab === 1) {
    const monday = today.subtract((today.day() + 6) % 7, 'day');
    return {
      start: monday.format('YYYY-MM-DD'),
      end: monday.add(6, 'day').format('YYYY-MM-DD'),
    };
  }
  if (subTab === 2) {
    return {
      start: today.startOf('month').format('YYYY-MM-DD'),
      end: today.endOf('month').format('YYYY-MM-DD'),
    };
  }
  return {
    start: null,
    end: today.subtract(1, 'day').format('YYYY-MM-DD'),
  };
};

const MyOwnFollowUpTab = () => {
  const [subTab, setSubTab] = useState(0);
  const range = getMyFollowUpRange(subTab);

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(event, newValue) => setSubTab(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 2,
          minHeight: 40,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            minHeight: 40,
            '&.Mui-selected': {
              color: '#7A3FFF',
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#7A3FFF',
          },
        }}
      >
        <Tab label="Today" />
        <Tab label="This Week" />
        <Tab label="This Month" />
        <Tab label="Expired Followup" />
      </Tabs>
      <FollowUpListByDate
        key={`my-followups-${subTab}`}
        followUpType="myFollowUps"
        presetStartDate={range.start}
        presetEndDate={range.end}
      />
    </Box>
  );
};

export default function FollowupAndLeadsPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem('userPermissions');
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewLeads = canShowPermission(permissions, 'leads', 'view');
  console.log('canViewLeads', canViewLeads);

  const tabs = [
    canViewLeads && {
      label: 'Leads',
      content: <CreateLeads />,
    },
    canViewLeads && {
      label: 'Follow Ups',
      content: <FollowUpListByDate followUpType="allFollowUp" />,
    },
    canViewLeads && {
      label: 'My Own Follow up',
      content: <MyOwnFollowUpTab />,
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto' }}>
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            width: '100%',
            mt: { xs: 10, md: 10 },
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Paper
            sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: '16px' }}
            elevation={1}
          >
            {/* Tabs */}
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                padding: '4px',
                '& .MuiTab-root': {
                  fontWeight: 600,
                  fontSize: '16px',
                  textTransform: 'none',
                  borderRadius: '6px',
                  margin: '0 4px',
                  minHeight: '48px',
                  '&.Mui-selected': {
                    backgroundColor: '#fff',
                    color: '#7A3FFF',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    borderBottom: '3px solid #7A3FFF',
                  },
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab key={index} label={tab.label} />
              ))}
            </Tabs>

            {/* Tab Content */}
            <Box sx={{ mt: 2 }}>{tabs[tabIndex]?.content}</Box>
          </Paper>
        </Box>
        <Box
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
          }}
        >
          {/* <InfoButton pageName="BOOKING_BULLION" /> */}
        </Box>
      </Box>
    </Box>
  );
}
